import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "common/hook";
import {logoutByUser} from "features/model/service/logout-by-user/LogoutByUser";
import {getProfileData} from "entities/Profile/model/selectors/getProfileData/getProfileData";
import {Avatar} from "./avatar/Avatar";
import {ProfileOptions} from "./profile-options/ProfileOptions";
import {ProfileName} from "./profile-name-props/ProfileNameProps";
import {Skeleton} from "antd";

type SizeType = 'default' | 'small' | 'large';


export const UserInfo: React.FC = () => {
    const dispatch = useAppDispatch();
    const dataProfile = useAppSelector(getProfileData);

    const [active, setActive] = useState(false);
    const [size, setSize] = useState<SizeType>('small');

    const onLogout = useCallback(() => {
        dispatch(logoutByUser());
    }, [dispatch]);

    const firstName = dataProfile?.firstName || null;
    const avatarSrc = dataProfile?.avatar || null;

    const [open, setOpen] = useState(false);
    const profileSelectRef = useRef<HTMLDivElement | null>(null);

    const onClickSelectHandler = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
        if (profileSelectRef.current && !profileSelectRef.current.contains(event.target as Node)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
            handleOutsideClick(event);
        };

        window.addEventListener('click', handleClickOutside);
        window.addEventListener('touchstart', handleClickOutside);

        return () => {
            window.removeEventListener('click', handleClickOutside);
            window.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);


    if (!firstName || !avatarSrc) {
        return (
            <div className="app-profile" ref={profileSelectRef}>
                <Skeleton.Input active={active} size={size} />
            </div>
        );
    }

    return (
        <div className="app-profile" ref={profileSelectRef}>
            <Avatar avatarSrc={avatarSrc} onClick={onClickSelectHandler}/>
            <div className="data-text">
                <ProfileOptions open={open} onLogout={onLogout}/>
                <ProfileName firstName={firstName} open={open} setOpen={setOpen}/>
                <span className="profile-post" onClick={onClickSelectHandler}>
                    {dataProfile?.roleName}
                </span>
            </div>
        </div>
    );
};
